import type { SystemSnapshot } from "@barmetvault/shared";
import {
  PageHeader,
  StatusBadge,
  ErrorState,
  PermissionDenied,
} from "../components/hub/OperationalUI";
import { useHubResource } from "./useHubResource";
export function SystemStatus({ status }: { status: SystemSnapshot }) {
  return (
    <div className="hub-grid">
      {Object.entries({
        API: status.api,
        DB: status.db,
        Nexus: status.nexus,
        'Runtime de agentes': status.hermes,
      }).map(([label, value]) => (
        <article className="hub-card" key={label}>
          <h2>{label}</h2>
          <StatusBadge status={value} />
        </article>
      ))}
      <article className="hub-card">
        <h2>Proceso API</h2>
        <dl className="hub-dl">
          <dt>Versión</dt>
          <dd>{status.version}</dd>
          <dt>Uptime (segundos)</dt>
          <dd>{Math.floor(status.uptime)}</dd>
          <dt>Comprobación</dt>
          <dd>{status.checkedAt}</dd>
        </dl>
      </article>
    </div>
  );
}
export default function SystemPage() {
  const result = useHubResource<SystemSnapshot>("/system/status");
  return (
    <section className="hub-page">
      <PageHeader
        title="Estado Sistema"
        subtitle="Comprobaciones del proceso API actual, sin telemetría estimada."
      />
      <div role="status">
        {result.state === "error"
          ? "UNAVAILABLE: no se pudo verificar API/DB."
          : result.state === "loading"
            ? "Consultando API…"
            : ""}
      </div>
      {result.state === "denied" ? (
        <PermissionDenied />
      ) : result.state === "error" ? (
        <ErrorState retry={result.retry} />
      ) : result.data ? (
        <SystemStatus status={result.data} />
      ) : null}
    </section>
  );
}
